import { Alert, Button, Modal } from 'antd'
import { FC, useState } from 'react'
import styled from 'styled-components'
import cantileverTheme from 'styles/cantileverTheme'

interface NiiSaveBannerProps {
  hasChanges: boolean
  isLoading: boolean
  isSaving: boolean
  onReset: () => void
  onSave: () => Promise<void>
}

export const NiiSaveBanner: FC<NiiSaveBannerProps> = ({
  hasChanges,
  isLoading,
  isSaving,
  onReset,
  onSave,
}) => {
  const [isConfirmSaveVisible, setIsConfirmSaveVisible] = useState(false)

  return (
    <>
      <StyledAlert
        title={hasChanges ? 'Save Changes?' : 'No Changes'}
        type={hasChanges ? 'warning' : 'success'}
        showIcon
        action={
          hasChanges && (
            <BannerActions>
              <CancelButton
                type='dashed'
                size='small'
                disabled={isLoading}
                onClick={onReset}>
                Reset
              </CancelButton>
              <SaveButton
                type='primary'
                size='small'
                disabled={isLoading}
                onClick={() => setIsConfirmSaveVisible(true)}>
                Save
              </SaveButton>
            </BannerActions>
          )
        }
      />
      <Modal
        title='Confirm Save'
        loading={isSaving}
        open={isConfirmSaveVisible}
        onOk={async () => {
          await onSave()
          setIsConfirmSaveVisible(false)
        }}
        onCancel={() => setIsConfirmSaveVisible(false)}
        okText='Save'
        cancelText='Cancel'
        confirmLoading={isSaving}>
        Are you sure you want to save these changes?
      </Modal>
    </>
  )
}

const StyledAlert = styled(Alert)`
  min-height: 48px;

  .ant-alert-content {
    display: flex;
    align-items: center;
  }
`

const BannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const CancelButton = styled(Button)`
  background-color: ${cantileverTheme.colors.grayscale['500']} !important;
`

const SaveButton = styled(Button)`
  background-color: ${cantileverTheme.colors.OceanBlue} !important;
`
